/**
 * Groups an array of seats by their area number and row index
 */
function groupSeatsByAreaNumberAndRowIndex(seats) {
    const groupMap = seats.reduce((acc, seat) => {
        const areaGroup = (acc[seat.position.areaNumber] = acc[seat.position.areaNumber] || {});
        const rowGroup = (areaGroup[seat.position.rowNumber] = areaGroup[seat.position.rowNumber] || []);
        rowGroup.push(seat);
        return acc;
    }, {});
    const groupArray = [];
    Object.values(groupMap).map(rowGroups => {
        Object.values(rowGroups).map(groupSeats => {
            groupArray.push(groupSeats);
        });
    });
    return groupArray;
}
/**
 * Sorts an array of seats by their column index in ascending order
 */
function sortSeatsByColumnIndex(seats) {
    return [...seats].sort((a, b) => a.position.columnNumber - b.position.columnNumber);
}
/**
 * Groups an array of seats into consecutive sub-arrays.
 * Assumes that all seats belong to the same row and area.
 */
function groupConsecutiveSeatsByColumnIndex(seats) {
    // Sort the seats by column index
    const sortedSeats = sortSeatsByColumnIndex(seats);
    return sortedSeats.reduce((acc, seat) => {
        const previousGroup = acc[acc.length - 1];
        // If there is no previous group, or if the last seat in the previous group doesn't have a
        // consecutive column index, add a new array to the accumulator
        if (!previousGroup ||
            previousGroup[previousGroup.length - 1].position.columnNumber !== seat.position.columnNumber - 1) {
            acc.push([]);
        }
        // Push the seat to the last array
        acc[acc.length - 1].push(seat);
        return acc;
    }, []);
}
/**
 * Groups consecutive seats in a given array of journey order seats or order seats.
 * Returns an array of seat groups.
 */
export function getConsecutiveSeatGroups(seats) {
    if (seats.length === 0)
        return [];
    const seatGroups = groupSeatsByAreaNumberAndRowIndex(seats);
    const consecutiveSeatGroups = seatGroups.map(groupConsecutiveSeatsByColumnIndex);
    return consecutiveSeatGroups.reduce((acc, group) => {
        group.forEach(groupSeats => {
            acc.push(groupSeats);
        });
        return acc;
    }, []);
}
